import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  reportCollectionsFilterSelector,
  reportFilterCountryCodeSelector,
  reportPettyCashDifferenceByPaymentTypeSelector,
} from '../../state';
import { PettyCashDifferenceByPaymentType } from '../../types';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../DataGridFlexSales';
import handlerFactory, { PettyCashDifferenceByPaymentTypeDataGridContext } from './handlerFactory';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<
    PettyCashDifferenceByPaymentType,
    PettyCashDifferenceByPaymentTypeDataGridContext
  >();
  const { t } = useTranslation();
  const title = {
    title: t('petty-cash-difference-by-payment-type.file-title'),
    tableTitle: t('petty-cash-difference-by-payment-type.title'),
  };
  const country = useSelector(reportFilterCountryCodeSelector);
  const reportCollectionsFilters = useSelector(reportCollectionsFilterSelector);

  const { loading, data } = useSelector(reportPettyCashDifferenceByPaymentTypeSelector);

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
    filters: reportCollectionsFilters,
  });

  return null;
};

const PettyCashDifferenceByPaymentTypeDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default PettyCashDifferenceByPaymentTypeDataGrid;
